import React from 'react';
import PropTypes from 'prop-types';
import noop from '../../../../core/modules/common/tools/noop';
import CheckboxTreeSelector from '../../../common/components/CheckboxTreeSelector';
import OnlySelectedFilterCheckbox from '../../../common/components/OnlySelectedFilterCheckbox';

const PostalOperatorSelector = (props) => {
  const {
    title = '',
    selected = [],
    onSelect = noop,
    onSelectAll = noop,
    onDeSelectAll = noop,
    isShowOnlySelected = false,
    onShowOnlySelected = noop,
    reportsNodes = [],
  } = props;

  return (
    <div className="operator-selector-container">
      {reportsNodes.length ?
        <CheckboxTreeSelector
          title={title}
          nodes={reportsNodes}
          selected={selected}
          expandDisabled
          onSelect={onSelect}
          onSelectAll={onSelectAll}
          onDeSelectAll={onDeSelectAll}
        /> : <div />
      }

      <div className="operator-selector-footer">
        <OnlySelectedFilterCheckbox
          isShowOnlySelected={isShowOnlySelected}
          onShowOnlySelected={onShowOnlySelected}
          isDisabled={selected.length === 0}
        />
      </div>
    </div>
  );
};

PostalOperatorSelector.propTypes = {
  title: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.string),
  onSelect: PropTypes.func,
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  reportsNodes: PropTypes.arrayOf(PropTypes.object),
  isShowOnlySelected: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
};

export default PostalOperatorSelector;
